import React from 'react';
import { CalendarRange, X } from 'lucide-react';

const pad = (n) => String(n).padStart(2, '0');
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const presets = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const daysAgo = (n) => ymd(new Date(y, m, now.getDate() - n));
  return [
    { id: '7d', label: '7 días', from: daysAgo(6), to: ymd(now) },
    { id: '30d', label: '30 días', from: daysAgo(29), to: ymd(now) },
    { id: 'month', label: 'Este mes', from: ymd(new Date(y, m, 1)), to: ymd(new Date(y, m + 1, 0)) },
    { id: 'prev', label: 'Mes pasado', from: ymd(new Date(y, m - 1, 1)), to: ymd(new Date(y, m, 0)) },
    { id: 'year', label: 'Este año', from: `${y}-01-01`, to: `${y}-12-31` },
    { id: 'lastyear', label: 'Año pasado', from: `${y - 1}-01-01`, to: `${y - 1}-12-31` },
  ];
};

// Date range selector with quick presets. value = { from, to } as 'YYYY-MM-DD' strings.
export const DateRangePicker = ({ value, onChange, onClear, idPrefix = 'range', showPresets = true }) => {
  const active = presets().find(p => p.from === value.from && p.to === value.to);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${idPrefix}-picker`}>
      <CalendarRange size={16} className="text-gray-400" />
      <input type="date" value={value.from || ''} max={value.to || undefined}
        onChange={e => onChange({ ...value, from: e.target.value })}
        className="h-9 px-2 rounded-md border border-gray-300 text-sm" data-testid={`${idPrefix}-from`} />
      <span className="text-gray-400 text-sm">→</span>
      <input type="date" value={value.to || ''} min={value.from || undefined}
        onChange={e => onChange({ ...value, to: e.target.value })}
        className="h-9 px-2 rounded-md border border-gray-300 text-sm" data-testid={`${idPrefix}-to`} />
      {showPresets && presets().map(p => (
        <button key={p.id} onClick={() => onChange({ from: p.from, to: p.to })}
          className={`px-2.5 py-1 rounded-full text-xs font-medium transition-colors ${active?.id === p.id ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
          data-testid={`${idPrefix}-preset-${p.id}`}>
          {p.label}
        </button>
      ))}
      {onClear && (value.from || value.to) && (
        <button onClick={onClear} className="p-1 text-gray-400 hover:text-gray-700" title="Quitar rango" data-testid={`${idPrefix}-clear`}>
          <X size={15} />
        </button>
      )}
    </div>
  );
};

export const rangeQuery = (value, fromKey = 'fecha_inicio', toKey = 'fecha_fin') => {
  const p = new URLSearchParams();
  if (value.from) p.set(fromKey, value.from);
  if (value.to) p.set(toKey, value.to);
  return p.toString();
};
